/* "My rewards" without signing in: the drawer's Rewards tab form (snippets/kk-rewards-lookup.liquid)
   asks the rewards Worker (POST /rewards/lookup) for the points and codes of the customer whose
   order number and phone or email are typed. Anything with [data-kkml-open] opens the drawer's
   Rewards tab (through [data-wl-rewards-open], assets/kk-wishlist.js) with the form open. */
(function () {
  var root = document.querySelector('[data-kkml]');
  if (!root || root.__kkml) return;
  root.__kkml = true;

  var toggle = root.querySelector('[data-kkml-toggle]');
  var body = root.querySelector('[data-kkml-body]');
  var form = root.querySelector('[data-kkml-form]');
  var go = form.querySelector('button[type="submit"]');
  var msg = root.querySelector('[data-kkml-msg]');
  var out = root.querySelector('[data-kkml-out]');
  var url = String(root.getAttribute('data-url') || '').replace(/\/+$/, '') + '/rewards/lookup';
  var FAILED = 'We couldn’t check right now. Please try again in a moment.';
  var WORDS = {
    not_found: 'We couldn’t match that order number with that phone or email. Check both and try again.',
    number_invalid: 'Enter the order number from your confirmation, like 3002.',
    contact_invalid: 'Enter the 10-digit phone number or the email you ordered with.',
    rate_limited: 'Too many tries. Please wait a minute and try again.',
    busy: FAILED
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function busy(on) { (window.kkBusy || function () {})(go, on); go.disabled = on; }
  function setOpen(on) {
    body.hidden = !on;
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) setTimeout(function () { form.elements.order.focus(); }, 60);
  }

  function show(r) {
    var codes = r.codes || [];
    root.querySelector('[data-kkml-points]').textContent = r.points;
    root.querySelector('[data-kkml-line]').textContent =
      r.points_to_next_code + ' more point' + (r.points_to_next_code === 1 ? '' : 's') + ' to your next ₹100 off · ' + r.tier + ' member';
    root.querySelector('[data-kkml-codes]').innerHTML = codes.map(function (c) {
      return '<li class="wl__rw-code"><span class="wl__rw-code-v">' + esc(c.worth) + '</span>' +
        '<button type="button" class="wl__rw-code-c" data-ctb-copy="' + esc(c.code) + '" aria-label="Copy the code ' + esc(c.code) + '">' + esc(c.code) + '</button>' +
        (c.use_by ? '<span class="wl__rw-code-x">Use by ' + esc(c.use_by) + '</span>' : '') + '</li>';
    }).join('');
    root.querySelector('[data-kkml-codes-h]').hidden = !codes.length;
    root.querySelector('[data-kkml-how]').hidden = !codes.length;
    root.querySelector('[data-kkml-none]').hidden = !!codes.length;
    out.hidden = false;
  }

  toggle.addEventListener('click', function () { setOpen(body.hidden); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var order = form.elements.order.value.trim();
    var contact = form.elements.contact.value.trim();
    if (!/\d{3,}/.test(order)) { msg.textContent = WORDS.number_invalid; return; }
    if (!contact) { msg.textContent = WORDS.contact_invalid; return; }
    msg.textContent = '';
    out.hidden = true;
    busy(true);
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ order: order, contact: contact }) })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (b) { return { ok: res.ok, b: b }; });
      })
      .then(function (r) {
        if (r.ok && r.b && r.b.rewards) { show(r.b.rewards); return; }
        msg.textContent = WORDS[r.b && r.b.error] || FAILED;
      })
      .catch(function () { msg.textContent = FAILED; })
      .then(function () { busy(false); });
  });

  // the Rewards page's "Check my points": open the drawer's Rewards tab, then this form
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-kkml-open]')) setTimeout(function () { setOpen(true); }, 0);
  });
})();
